<ng-container *transloco="let _t">

<div id="login" *ngIf="show=='login'" class="login">
	<!--<mat-form-field>
		<label for="lang">{{_t('Language')}}</label>
		<mat-select matInput name="lang" [(ngModel)]="lang">
			<mat-option [value]="'fr'">Français</mat-option>
			<mat-option [value]="'en'">English</mat-option>
		</mat-select>
	</mat-form-field>-->
	<p *ngIf="failLogin" style="color:#f44336;">E-mail ou mot de passe invalide</p>
	<mat-form-field>
		<label for="username">Email</label>
		<input matInput type="email" name="username" [(ngModel)]="username" (keydown)="login($event)"/>
	</mat-form-field>
	<mat-form-field>
		<label for="password">{{_t('Password')}}</label>
		<input matInput type="password" name="password"[(ngModel)]="password" (keydown)="login($event)" />
	</mat-form-field>
	<p>&nbsp;</p>
	<p class="text-center"><button mat-raised-button color="accent" (click)="login($event)" (keydown)="login($event)">
		{{ _t('Connexion')}}
	</button></p>
	<p class="text-center">
		<a href="{{forgotLink}}">{{ _t('login-regen') }}</a>
		<!--<a href="#" (click)="show='forgot'">{{ _t('login-regen') }}</a>-->
	</p>
</div>

<div id="forgot" *ngIf="show=='forgot'" class="login darkbg">
	<h5>{{ _t('login-forgot-h5') }} </h5>
	<p>{{ _t('login-forgot-p') }}</p>
	<mat-form-field>
		<label for="username">Email</label>
		<input matInput type="text" name="username" [(ngModel)]="username" (keydown)="forgot($event)"/>
	</mat-form-field>
	<p class="text-center"><button mat-raised-button color="accent" (click)="forgot($event)" (keydown)="forgot($event)">
		{{ _t('Envoi') }}
	</button></p>
	<p class="text-center">
		<a href="#" (click)="show='login'">{{ _t('login-a-back') }}</a>
	</p>
</div>

</ng-container>